"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { tbSelectionBtnClicked } from "Actions/Table/TableToolBarActions";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";

var SelectAllProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(SelectAllProps, _BaseToolbarButtonPro);

  function SelectAllProps(_ref) {
    var _this;

    var formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu"]);

    _classCallCheck(this, SelectAllProps);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: Messages.Controls.SelectAll,
      hint: Messages.Controls.SelectAllHint,
      iconType: 'fontawesome:select-all-button far fa-check-square',
      elementAttr: {
        'class': "table-form-select-all"
      },
      onClick: function onClick() {
        _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
        tbSelectionBtnClicked({
          formUUID: _this.UUID,
          selection: true
        });
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectAllProps).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    return _this;
  }

  return SelectAllProps;
}(BaseToolbarButtonProp);

_defineProperty(SelectAllProps, "create", function (options) {
  return new SelectAllProps(options).props();
});

export { SelectAllProps as default };